import { isDesktop, timingDelay } from '../utils';

export default class ModSpecifications {
  constructor(el) {
    this.$el = $(el);
    this.classes = {
      show: 'show',
      opacityZeroAndPointerEventsNone: 'opacity-0 pointer-events-none',
    };

    this.attributes = {
      ariaExpanded: 'aria-expanded',
      ariaLabelledby: 'aria-labelledby',
    };

    this.dom = {
      $buttonShowMore: this.$el.find('.button-show-more'),
      $buttonShowLess: this.$el.find('.button-show-less'),
      $contentShowMore: this.$el.find('.content-show-more'),
    };

    this.init();
  }

  init() {
    this.addListeners();
  }

  addListeners() {
    this.dom.$buttonShowMore.on('click', (event) => {
      this.eventOnClickButtonShowMore(event);
    });

    this.dom.$buttonShowLess.on('click', (event) => {
      this.eventOnClickButtonShowLess(event);
    });
  }

  eventOnClickButtonShowMore(event) {
    const $elementCurrentTarget = $(event.currentTarget);
    if (!this.dom.$contentShowMore.hasClass(this.classes.show)) {
      this.dom.$contentShowMore.addClass(this.classes.show).slideDown(700).attr(this.attributes.ariaLabelledby, 'specifications-accordion2id');
      $elementCurrentTarget.addClass(this.classes.opacityZeroAndPointerEventsNone).attr(this.attributes.ariaExpanded, 'true');
      this.dom.$buttonShowLess.attr(this.attributes.ariaExpanded, 'true');
    }
  }

  eventOnClickButtonShowLess(event) {
    const $elementCurrentTarget = $(event.currentTarget);
    if (this.dom.$contentShowMore.hasClass(this.classes.show)) {
      this.dom.$contentShowMore.removeClass(this.classes.show).attr(this.attributes.ariaLabelledby, 'specifications-accordion1id');
      this.dom.$buttonShowMore.removeClass(this.classes.opacityZeroAndPointerEventsNone).attr(this.attributes.ariaExpanded, 'false');
      $elementCurrentTarget.attr(this.attributes.ariaExpanded, 'false');
      this.eventScrollToButtonShowMore();
      timingDelay(300, () => {
        this.dom.$contentShowMore.slideUp(700);
      });
    }
  }

  eventScrollToButtonShowMore() {
    const heightHeader = $('header').height();
    let offsetNavigation = heightHeader;

    if ($('.mod-sub-navigation').length > 0) {
      const groupContentTopHeight = $('.js-group-content-top').height();
      offsetNavigation = groupContentTopHeight + heightHeader;
    }

    if (isDesktop()) {
      window.scrollAgent.$scrollEvent.scrollTo(this.dom.$buttonShowMore.get(0), {
        offset: -offsetNavigation - 20,
        duration: 600,
      });
    } else {
      $('html, body').animate({
        scrollTop: this.dom.$buttonShowMore.offset().top - offsetNavigation - 20,
      }, 600);
    }
  }
}
